module.exports = __webpack_public_path__ + "static/media/(banner)-Monte-Seu-Biquini-(site).65ac2983.jpg";